<template>
  <div class="app-product-aid-card-body">
    <NuxtImg
      v-if="image && !isRegional"
      :src="image"
      :alt="title"
      provider="storyblok"
      :height="getImageDimensionsFromStoryblokSrc(image).height"
      :width="getImageDimensionsFromStoryblokSrc(image).width"
      class="app-product-aid-card-body__image"
    />

    <div class="app-product-aid-card-body__info">
      <template v-if="isRegional">
        <h3 v-if="showTitle" class="app-product-aid-card-body__title h4">Krant uit je regio</h3>
        <p v-if="subtitle" class="app-product-aid-card-body__subtitle">{{ subtitle }}</p>
        <TappButton class="app-product-aid-card-body__cta" @click="$emit('select-regional')">
          {{ t('marketingPages.productAid.cardBody.chooseRegion') }}
          <TappIcon icon="arrow-right" :size="16" />
        </TappButton>
      </template>

      <template v-else>
        <h3 v-if="showTitle" class="app-product-aid-card-body__title h4">{{ title }}</h3>
        <p v-if="subtitle" class="app-product-aid-card-body__subtitle">{{ subtitle }}</p>
        <TappButton :to="link" class="app-product-aid-card-body__cta">
          {{ t('marketingPages.productAid.cardBody.readFree') }}
          <TappIcon icon="arrow-right" :size="16" />
        </TappButton>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
  const { t } = useI18n();

  defineProps<{
    title?: string;
    subtitle?: string;
    image?: string;
    link?: string;
    isRegional?: boolean;
    showTitle?: boolean;
  }>();

  defineEmits<{
    'select-regional': [];
  }>();
</script>

<style lang="postcss" scoped>
  .app-product-aid-card-body {
    display: flex;
    gap: var(--spacing-4);
    padding: var(--spacing-4) var(--spacing-4) 0;
    background: #f5f5f4;

    &__image {
      width: 100%;
      max-width: 7.5rem;
      height: auto;
      max-height: 152px;
      border-radius: 10% 10% 0 0;

      object-fit: cover;
      object-position: top;
      box-shadow: 0 0 3.735px 0 rgb(0 0 0 / 10%);
    }

    &__subtitle {
      margin: 0;
    }

    &__info {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-2);
      align-items: center;
      justify-content: center;

      width: 100%;
      padding-bottom: var(--spacing-4);
    }
  }
</style>
